import React from 'react';
import HelpPanel from '@cloudscape-design/components/help-panel';
import { ExternalLinkGroup } from './common';

export function ConfigurationHelp() {
  return (
    <HelpPanel
      header={<h2>Configuration</h2>}
      footer={
        <ExternalLinkGroup
          items={[
            { href: '#', text: 'System Architecture Documentation' },
            { href: '#', text: 'AWS Services Integration Guide' },
            { href: '#', text: 'Security Best Practices' }
          ]}
        />
      }
    >
      <p>
        The Configuration page allows administrators to manage system settings and integrations.
      </p>
      
      <h3>General Settings</h3>
      <p>
        The General Settings tab contains core system configuration:
      </p>
      <ul>
        <li><strong>Environment Mode</strong>: Toggle between development and production environments</li>
        <li><strong>Development Email</strong>: Email address used for testing in development mode</li>
        <li><strong>Source Email</strong>: The sender address for all notification emails</li>
        <li><strong>Days Before Escalation</strong>: How long to wait before escalating unread notifications to Slack</li>
      </ul>
      
      <h3>Development Mode</h3>
      <p>
        When development mode is enabled:
      </p>
      <ul>
        <li>All emails are sent to the development email address instead of actual account managers</li>
        <li>Additional logging is activated for debugging</li>
        <li>Slack notifications use test channels instead of production channels</li>
      </ul>
      
      <h3>Advanced AWS Settings</h3>
      <p>
        The expandable section contains AWS-specific configuration:
      </p>
      <ul>
        <li><strong>SES Configuration Set</strong>: The Amazon SES configuration set used for email tracking</li>
      </ul>
      
      <h3>Integrations</h3>
      <p>
        The Integrations tab manages external service connections:
      </p>
      <ul>
        <li><strong>Slack Webhook URL</strong>: The webhook URL for sending notifications to Slack</li>
      </ul>
      
      <h3>Infrastructure Info</h3>
      <p>
        The Infrastructure Info tab provides details about the system architecture:
      </p>
      <ul>
        <li><strong>Database Connections</strong>: Information about Redshift and PostgreSQL databases</li>
        <li><strong>Configuration Architecture</strong>: Overview of how configuration is managed across the system</li>
      </ul>
      
      <h3>Testing Connections</h3>
      <p>
        Use the "Test Connections" button to verify that all integrations are working correctly. This will check:
      </p>
      <ul>
        <li>Database connectivity</li>
        <li>Email sending capability</li>
        <li>Slack webhook functionality</li>
      </ul>
      
      <h3>Saving Settings</h3>
      <p>
        Changes to application settings take effect immediately when you click "Save Settings". Infrastructure changes may require redeployment of the CDK stack.
      </p>
    </HelpPanel>
  );
}
